module.exports = __webpack_public_path__ + "static/media/pbsg1.22edc7f0.png";